<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild header" :class="{ 'not-top': pageYOffset > 0 }" @mouseenter="isHover = true" @mouseleave="isHover = false">
    <!-- 电脑导航 -->
    <div class="hidden-xs">
      <div class="header-nav">
        <div style="display: flex;align-items: center">
          <!-- 导航logo -->
          <img class="header-nav-logo" :src="currentLogo" alt="logo">
          <!-- 导航内容 -->
        </div>
        <div class="header-nav-right">
          <ul class="header-nav-wrapper">
            <li
              v-for="(item,index) in navList"
              :key="index"
              :class="index==navIndex?'active':''"
              @click="navClick(index,item.name)"
            >
              <router-link :to="item.path">
                {{item.name}}
                <span v-if="item.children.length>0" class="glyphicon glyphicon-menu-down"></span>
                <i class="underline"></i>
              </router-link>
              <dl v-if="item.children.length>0">
                <dt v-for="(i,n) in item.children" :key="n">
                  <router-link :to="i.path">{{i.name}}</router-link>
                </dt>
              </dl>
            </li>
          </ul>
          <span :class="{ active: lang === 'en' }" @click="switchLang('en')">EN</span>
          <span :class="{ active: lang !== 'en' }" @click="switchLang('zh')">中</span>
        </div>
      </div>
    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs">
      <!-- 导航栏 -->
      <div class="header-nav-m-menu text-right">
        <img class="center-block" :src="logoColor" alt="logo">
        <span :class="{ active: lang === 'en' }" @click="switchLang('en')">EN</span>
        <span :class="{ active: lang !== 'en' }" @click="switchLang('zh')">中</span>
        <i style="display:inline-block;width: 30px;"></i>
        <span style="padding-right: 80px;">{{menuName}}</span>
        <div
          class="header-nav-m-menu-wrapper"
          data-toggle="collapse"
          data-target="#menu"
          @click="menuClick"
        >
          <span :class="menuClass"></span>
        </div>
        <!-- 导航内容 -->
        <ul id="menu" class="header-nav-m-wrapper text-center collapse">
          <li
            v-for="(item,index) in navList"
            :key="index"
            :class="index==navIndex?'activeli':''"
            @click="navClick(index,item.name)"
            data-toggle="collapse"
            data-target="#menu"
          >
            <router-link :to="item.path">
              {{item.name}}
              <i class="underline"></i>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import api, { fileUrl } from '@/api/api'
// 兜底 logo: 后台未配置时回退到本地静态图,保证始终可见
import logoColorFallback from '@/assets/img/logo-color.png'
import logoLightFallback from '@/assets/img/logo.png'

export default {
  name: "Header",
  data() {
    return {
      pageYOffset: 0,
      lang: localStorage.getItem('lang'),
      navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,
      menuName: this.$t('header.home'),
      menuClass: "glyphicon glyphicon-menu-down",
      // logo: 默认本地兜底,loadConfig 成功后覆盖为后台配置地址
      logoColor: logoColorFallback,
      logoLight: logoLightFallback,
      isHover: false,
      navList: [
        {
          name: this.$t('header.home'),
          path: "/",
          children: []
        },
        {
          name: this.$t('header.aboutUs'),
          path: "/companyintroduction",
          children: []
        },
        {
          name: this.$t('header.productService'),
          path: "/software",
          children: []
        },
        {
          name: this.$t('header.rdCenter'),
          path: "/service",
          children: [
            {
              name: this.$t('header.veterinary'),
              path: "/service/smartTown",
            },
            {
              name: this.$t('header.highEnd'),
              path: "/service/bigData",
            }
          ]
        },
        {
          name: this.$t('header.ourTeam'),
          path: "/companygroups",
          children: []
        },
        /*{
          name: "工作机会",
          path: "/jobchance",
          children: []
        },*/
        {
          name: this.$t('header.news'),
          path: "/newsinformation",
          children: []
        },
        {
          name: this.$t('header.contactUs'),
          path: "/contactus",
          children: []
        }
      ]
    };
  },
  computed: {
    // 桌面端当前 logo: 透明顶栏默认态=白色版,滚动后或鼠标悬停=彩色版
    currentLogo() {
      return (this.pageYOffset > 0 || this.isHover) ? this.logoColor : this.logoLight
    }
  },
  mounted() {
    this.pageYOffset = window.scrollY;
    window.addEventListener('scroll', () => {
      this.pageYOffset = window.scrollY;
    });
    this.loadConfig();
  },
  methods: {
    async loadConfig() {
      try {
        const kv = await api.configAll();
        // 彩色版(滚动/悬停态)
        const color = kv['site_logo'];
        if (color && color.image && color.record) {
          this.logoColor = fileUrl(color.record, color.image);
        }
        // 白色版(透明顶栏默认态)
        const light = kv['site_logo_light'];
        if (light && light.image && light.record) {
          this.logoLight = fileUrl(light.record, light.image);
        }
      } catch (e) { /* 读取失败保持本地兜底图 */ }
    },
    navClick(index, name) {
      this.navIndex = index;
      sessionStorage.setItem('navIndex',index)
      this.menuName = name;
    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    },
    switchLang(lang) {
      this.lang = lang
      this.$i18n.locale = lang
      localStorage.setItem('lang', lang)
      window.location.reload()
    }
  }
};
</script>
<style scoped>
/* 顶部 */
.header {
  width: 100%;
  position: fixed;
  top: 0;
  transition: all ease .6s;
  background: rgba(0,0,0,0.1);
  border-bottom: 1px solid rgba(255,255,255,0.2);
  z-index: 99;
}
.header:hover {
  background: #fff;
  color: #333333;
}
.not-top {
  background: #fff;
  color: #333333;
}
/* 导航栏 */
.header .header-nav {
  /*height: 86px;*/
  display: flex;
  align-items: center;
  justify-content: space-between;
}
/* 导航栏logo */
.header .header-nav .header-nav-logo {
  display: inline-block;
  width: 102px;
  height: 66px;
  margin-left: 5vw;
  object-fit: contain;
}
/* 导航栏 导航容器 */
.header .header-nav-fixed .header-nav-wrapper {
  line-height: 50px;
}
.header .header-nav .header-nav-wrapper {
  display: flex;
  line-height: 85px;
  max-width: 1000px;
  margin: 0 10vw 0 10px;
  flex-wrap: wrap;
}
.header .header-nav .header-nav-right {
  color: #fff;
  font-size: 15px;
  font-weight: bold;
  display: flex;
  align-items: center;
  margin-right: 5vw;
}
.header .header-nav .header-nav-right span {
  cursor: pointer;
  display: inline-block;
  width: 40px;
  height: 40px;
  line-height: 40px;
  border-radius: 20px;
  font-weight: bold;
  text-align: center;
  flex-shrink: 0;
}
.header .header-nav .header-nav-right .glyphicon {
  width: 20px;
}
.header:hover .header-nav .header-nav-right {
  color: #333;
}
.header:hover .header-nav .header-nav-right .active {
  color: #fff;
}
.not-top .header-nav .header-nav-right {
  color: #333;
}
.not-top .header-nav .header-nav-right .active {
  color: #fff;
}
.header .header-nav .header-nav-right > .active {
  background: #15adfc;
}
.header-nav-m-menu span {
  padding: 5px;
}
.header-nav-m-menu span:nth-of-type(0) {
  transform: translateX(-100px);
}
.header-nav-m-menu .active {
  padding: 5px;
  color: #fff;
}
.header-nav-m-menu .active {
  background: #15adfc;
  border-radius: 20px;
}
.header-nav-m-menu .activeli {
  background: #15adfc;
}
.header-nav-m-menu .activeli a {
  color: #fff !important;
}
/* 导航栏 每个导航 */
.header .header-nav .header-nav-wrapper > li:first-child {
  margin-left: 30px;
}
.header .header-nav .header-nav-wrapper > li {
  margin: 0 15px;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接 */
.header .header-nav .header-nav-wrapper > li > a {
  color: #fff;
  font-size: 16px;
  font-weight: bold;
  padding: 15px 0;
  position: relative;
}
.header:hover .header-nav .header-nav-wrapper > li > a {
  color: #333;
}
.not-top .header-nav .header-nav-wrapper > li > a {
  color: #333;
}
/* 导航栏 每个导航下面的 a 链接的下划线 */
.header .header-nav .header-nav-wrapper > li > a > i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #1e73be;
}
/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
.header .header-nav .header-nav-wrapper > li > a > span {
  font-size: 12px;
  transition: transform ease 0.5s;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
.header .header-nav .header-nav-wrapper > li > a:hover {
  color: #1e73be;
  text-decoration: none;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
.header .header-nav .header-nav-wrapper > li > a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
.header .header-nav .header-nav-wrapper > li > a:hover span {
  transform: rotate(180deg);
}
/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
.header .header-nav .header-nav-wrapper > li.active > a {
  color: #01afeb;
  text-decoration: none;
  border-bottom: 2px solid #01afeb;
}
/* 导航栏 每个导航下面的二级导航容器 */
.header .header-nav .header-nav-wrapper > li > dl {
  display: none;
  position: absolute;
  width: 198px;
  top: 80%;
  left: 0;
  z-index: 999999;
  background: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 */
.header .header-nav .header-nav-wrapper > li > dl > dt {
  width: 100%;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
.header .header-nav .header-nav-wrapper > li > dl > dt > a {
  display: block;
  color: #666;
  padding: 10px 10px 10px 30px;
  line-height: 30px;
}
.header .header-nav .header-nav-wrapper > li > dl > dt > a:hover {
  text-decoration: none;
}
/* 导航栏 滑上一级导航显示二级导航 */
.header .header-nav .header-nav-wrapper > li:hover dl {
  display: block;
}
.header .header-nav .header-nav-wrapper > li > dl > dt:hover {
  cursor: pointer;
  background: #093a92;
}
.header .header-nav .header-nav-wrapper > li > dl > dt:hover > a {
  color: #fff;
}

@media screen and (max-width: 997px) {
  .header .header-nav-m {
    position: relative;
    display: flex;
  }

  /* 导航栏logo图片 */
  .header .header-nav-m img {
    width: 81px;
    height: 45px;
    position: absolute;
    left: 20px;
    margin: auto;
  }
  /* 导航栏  菜单容器 */
  .header .header-nav-m .header-nav-m-menu {
    color: #333;
    height: 80px;
    padding: 15px 0;
    font-size: 16px;
    line-height: 50px;
    background: #fff;
    position: relative;
  }
  .glyphicon {
    top: -3px;
  }
  /* 导航栏 菜单图标 */
  .header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 20px;
    margin-top: -20px;
    width: 50px;
    height: 40px;
    color: #333;
    z-index: 999999;
    font-size: 12px;
  }
  /* 导航栏 */
  .header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 70px;
    left: 0;
    width: 100%;
    background: #fff;
    z-index: 9999999;
  }
  /* 导航栏 每个导航 */
  .header .header-nav-m .header-nav-m-wrapper > li {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #ccc;
  }
  /* 导航栏 每个导航下面的 a 链接 */
  .header .header-nav-m .header-nav-m-wrapper > li > a {
    display: block;
    color: #333;
    font-size: 15px;
    font-weight: bold;
    position: relative;
  }
  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  .header .header-nav .header-nav-wrapper > li > a > span {
    font-size: 10px;
    line-height: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue